<script>
import { mapActions, mapState } from 'vuex';
import ModalAnswerTemplate from 'components/ModalAnswerTemplate';
import ModalAnswerTemplateWithMarkers from 'components/ModalAnswerTemplateWithMarkers';
import ModalChangeSkill from 'components/ModalChangeSkill';
import ModalChannelSkill from 'components/ModalChannelSkill';
import ModalConfirm from 'components/ModalConfirm';
import ModalExistingCase from 'components/ModalExistingCase';
import ModalForgotPassword from 'components/ModalForgotPassword';
import ModalInfo from 'components/ModalInfo';
import ModalInfoInTable from 'components/ModalInfoInTable';
import ModalNewCase from 'components/ModalNewCase';
import ModalTransfer from 'components/ModalTransfer';
import ModalIndividualStatistic from 'components/ModalIndividualStatistic';
import ModalAddMarker from 'components/ModalAddMarker';
import ModalWaitReport from 'components/ModalWaitReport';
import ModalAddTemplate from 'components/ModalAddTemplate';
import ModalRequestToDepartment from 'components/ModalRequestToDepartment';
import ModalUcceAgents from 'components/ModalUcceAgents';
import ModalConfirmPassword from 'components/ModalConfirmPassword';
import ModalDirectorySkill from 'components/ModalDirectorySkill';
import ModalDirectorySkillsPriorities from 'components/ModalDirectorySkillsPriorities';
import ModalCreateEmailActivity from 'components/ModalCreateEmailActivity';

export default {
  components: {
    ModalAnswerTemplate,
    ModalAnswerTemplateWithMarkers,
    ModalChangeSkill,
    ModalChannelSkill,
    ModalConfirm,
    ModalExistingCase,
    ModalForgotPassword,
    ModalInfo,
    ModalInfoInTable,
    ModalNewCase,
    ModalTransfer,
    ModalIndividualStatistic,
    ModalAddMarker,
    ModalWaitReport,
    ModalAddTemplate,
    ModalRequestToDepartment,
    ModalUcceAgents,
    ModalConfirmPassword,
    ModalDirectorySkill,
    ModalDirectorySkillsPriorities,
    ModalCreateEmailActivity,
  },
  created() {
    window.addEventListener('keydown', this.eventHandler);
    const menuStyle = '.menu__content{z-index: 10009}';
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.id = 'styleOfMenuTeams';
    styleSheet.innerText = menuStyle;
    document.head.appendChild(styleSheet);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.eventHandler);
    const styleSheet = document.getElementById('styleOfMenuTeams');
    if (styleSheet) styleSheet.parentNode.removeChild(styleSheet);
  },
  methods: {
    ...mapActions('overlay', ['toggleModal']),
    eventHandler(e) {
      if (e.keyCode === 27) {
        e.preventDefault();
        this.close([null]);
      }
    },
    close() {
      this.toggleModal([null]);
    },
  },
  computed: {
    ...mapState('overlay', ['value', 'component']),
    ...mapState('app', ['mode', 'isFrame']),
    ...mapState('overseer', ['loadingReport']),
    ...mapState('home', ['ucceIntegration']),
    ucceEnabled() {
      return this.ucceIntegration;
    },
    miniMode() {
      return this.mode === 'MINI' && this.isFrame && !this.ucceEnabled;
    },
    fullMode() {
      return this.mode === 'FULL' || !this.isFrame;
    },
  },
};
</script>

<template lang="pug">
div(:class="[$style.root, $style.show]")
  div(:class="$style.overlay", @click="close([null])")
  div(:class="[$style.content, miniMode && $style.contentMini]")
    component(:is="`Modal${component}`", :key="component", :value="value")
</template>

<style lang="sass" module>
.root
  display: flex
  position: fixed
  z-index: 10000
  user-select: none
  background-color: $color_transparent
  left: 0
  right: 0
  top: 0
  bottom: 0
  justify-content: center
  align-items: center
  transition: background-color $a_speed
.overlay
  position: absolute
  z-index: 10
  left: 0
  right: 0
  top: 0
  bottom: 0
.show
  background-color: $color_transparent_bg_dark_third
.content
  background-color: $color_bg_light
  border-radius: 5px
  user-select: text
  box-shadow: $sh_dp3
  max-width: 100%
  max-height: 100%
  transition: opacity $a_speed, transform $a_speed
  overflow: auto
  z-index: 20
  &Mini
    overflow: hidden
    &:hover
      overflow-y: auto

</style>
